// extracted by mini-css-extract-plugin
export default {"title":"LoginForm_title__ZoEy1","form":"LoginForm_form__n9aqh","submit":"LoginForm_submit__T04iy","forgotPassword":"LoginForm_forgotPassword__Kcq-1"};